var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 15.206,
    height: 15.206,
    viewBox: "0 0 15.206 15.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-3{fill:#3f66b3}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__ic-actions-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rect\\xE1ngulo_25",
    fill: "none",
    d: "M0 0H15.206V15.206H0z",
    "data-name": "Rect\\xE1ngulo 25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer-2",
    "data-name": "Layer",
    transform: "translate(.621 .621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_64",
    fill: "#3f66b3",
    fillRule: "evenodd",
    d: "M1 7.834a6.834 6.834 0 1 1 6.834 6.834A6.834 6.834 0 0 1 1 7.834zm6.834-5.591a5.591 5.591 0 1 0 5.591 5.591 5.591 5.591 0 0 0-5.591-5.591z",
    "data-name": "Trazado 64",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_65",
    d: "M11.621 13.454A.584.584 0 0 1 11 12.92V6.533a.628.628 0 0 1 1.243 0v6.387a.584.584 0 0 1-.621.534z",
    className: "prefix__cls-3",
    "data-name": "Trazado 65",
    transform: "translate(-4.787 -2.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_66",
    d: "M6 11.621A.584.584 0 0 1 6.533 11h6.387a.628.628 0 0 1 0 1.243H6.533A.584.584 0 0 1 6 11.621z",
    className: "prefix__cls-3",
    "data-name": "Trazado 66",
    transform: "translate(-2.893 -4.787)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.7b9ea785.svg";
export { ForwardRef as ReactComponent };